export default "__VITE_ASSET__DACZqFdC__"